import { VisitSettlementAdjustment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { AdjustmentByFormBean, AdjustmentFormBean } from './adjustment.types';

type CreateAdjustmentByFormBeanOptions = {
   adjustment: VisitSettlementAdjustment | undefined;
};

export const createAdjustmentByFormBean = (
   options: CreateAdjustmentByFormBeanOptions
): AdjustmentByFormBean | undefined => {
   if (!options.adjustment) {
      return undefined;
   }

   const {
      adjustedBy: { firstName, lastName },
      adjustmentDate,
   } = options.adjustment;

   return {
      author: [firstName, lastName].join('\u00A0'),
      date: adjustmentDate,
   };
};

type CreateAdjustmentFormBeanOptions = {
   adjustment: VisitSettlementAdjustment | undefined;
   canAdjustment: boolean;
};

export const createAdjustmentFormBean = (options: CreateAdjustmentFormBeanOptions): AdjustmentFormBean | undefined => {
   if (!options.canAdjustment) {
      return undefined;
   }
   if (options?.adjustment) {
      return {
         previousAdjustment: {
            by: createAdjustmentByFormBean({
               adjustment: options.adjustment,
            }),
            note: options.adjustment.adjustmentNote,
         },
         note: null,
      };
   }

   return {
      note: null,
   };
};
